import { Button, Card, Col, Form, Input, Row, Typography } from "antd";
import React, { useState } from "react";
import styles from "./Login.module.css";
import { useDispatch } from "react-redux";
import { addUser, forgotPassword } from "../../redux/rtk/features/user/userSlice";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";

const Login = () => {
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const { Title } = Typography;

  const onFinish = async (values) => {
    setLoader(true);
    const resp = await dispatch(addUser(values));
    if (resp.type === "user/addUser/fulfilled" && resp.payload.message === "success") {
      setLoader(false);
      window.location.href = "/admin/dashboard";
    } else {
      setLoader(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    // console.log("Failed:", errorInfo);
    setLoader(false);
    toast.error("Error at login. Please try again");
  };

  const onForgotPasswordFinish = async (values) => {
    setLoader(true);
    const resp = await dispatch(forgotPassword(values));
    setLoader(false);
    if (resp.payload?.message === "success") {
      setShowForgotPassword(false);
    }
  };

  const onForgotPasswordFailed = (errorInfo) => {
    // console.log("Forgot Password Failed:", errorInfo);
    setLoader(false);
    toast.error("Error resetting password. Please try again");
  };

  return (
    <>
      <Row className="card-row">
        <Col span={24}>
          <Card bordered={false} className={styles.card}>
            {showForgotPassword ? (
              <>
                <Title level={3} className="m-3 text-center">
                  Forgot Password
                </Title>
                <Form
                  name="forgotPasswordForm"
                  labelCol={{ span: 6 }}
                  wrapperCol={{ span: 16 }}
                  onFinish={onForgotPasswordFinish}
                  onFinishFailed={onForgotPasswordFailed}
                  autoComplete="off"
                >
                  <Form.Item
                    className="mb-5"
                    label="Email"
                    name="email"
                    rules={[
                      {
                        required: true,
                        message: "Please input your email!",
                      },
                      {
                        type: "email",
                        message: "Please enter a valid email address!",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item className={styles.submitBtnContainer}>
                    <Button type="primary" htmlType="submit" loading={loader}>
                      Submit
                    </Button>
                  </Form.Item>
                  <div className="text-center mt-2">
                    <Button type="link" onClick={() => setShowForgotPassword(false)}>
                      Back to Login
                    </Button>
                  </div>
                </Form>
              </>
            ) : (
              <>
                <Title level={3} className="m-3 text-center">
                  Login
                </Title>
                <Form
                  name="basic"
                  labelCol={{ span: 6 }}
                  wrapperCol={{ span: 16 }}
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                  autoComplete="off"
                >
                  <Form.Item
                    className="mb-5"
                    label="UserName"
                    name="UserName"
                    rules={[
                      {
                        required: true,
                        message: "Please input your UserName!",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item
                    className="mb-5"
                    label="Password"
                    name="UserPassword"
                    rules={[
                      {
                        required: true,
                        message: "Please input your password!",
                      },
                    ]}
                  >
                    <Input.Password />
                  </Form.Item>

                  <Form.Item className={styles.submitBtnContainer}>
                    <Button
                      type="primary"
                      htmlType="submit"
                      loading={loader}
                      onClick={() => setLoader(true)}
                    >
                      Submit
                    </Button>
                  </Form.Item>
                  <div className="text-center mt-2">
                    <Button type="link" onClick={() => setShowForgotPassword(true)}>
                      Forgot Password?
                    </Button>
                  </div>

                  <div className="text-center mt-3">
                    <Link
                      to="/privacy-policy/"
                      target="_blank"
                      style={{
                        color: "var(--text-color-secondary)",
                        fontSize: "14px",
                        textDecoration: "underline",
                      }}
                    >
                      Privacy Policy
                    </Link>
                  </div>
                </Form>
              </>
            )}
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default Login;